__turbopack_export_value__({
  "cards": "cardListAboutClinic-module-scss-module__k1mSba__cards",
});
